import { Outlet } from 'react-router'
import { Sidebar } from '@/components/Sidebar'
import { useFleetSummaryQuery } from '@/features/fleet/hooks/useFleetSummaryQuery'
import './AppLayout.css'

export function AppLayout() {
  const fleetQuery = useFleetSummaryQuery()
  const counts = fleetQuery.data?.detectionCounts

  return (
    <div className="app-layout">
      <Sidebar
        detectionBadgeCount={counts ? counts.critical + counts.high : 0}
        rulesVersion={fleetQuery.data?.rulesVersion}
        lastRulePush={fleetQuery.data?.lastRulePush}
      />
      <main className="app-layout__content">
        <div className="app-layout__inner">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
